import {
  AppstoreOutlined,
  BookOutlined,
  FileTextOutlined,
  FolderOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import { ItemType } from "../useLibrary";
import { Tooltip } from "antd";

export const ItemTypeIcon = (props: {
  type: ItemType;
  size?: number;
  style?: React.CSSProperties;
}) => {
  switch (props.type) {
    case ItemType.SPACES: {
      return (
        <Tooltip title="Space - a place to store your most used items on VZBL.">
          <FolderOutlined style={{ fontSize: props.size, ...props.style }} />
        </Tooltip>
      );
    }
    case ItemType.BOARDS: {
      return (
        <Tooltip title="Board - an organized collection of queries.">
          <AppstoreOutlined style={{ fontSize: props.size, ...props.style }} />
        </Tooltip>
      );
    }
    case ItemType.QUERIES: {
      return (
        <Tooltip title="Query - a question you want to ask of your data.">
          <FileTextOutlined style={{ fontSize: props.size, ...props.style }} />
        </Tooltip>
      );
    }
    case ItemType.TOPICS: {
      return (
        <Tooltip title="Topic - a detailed AI analysis of specific queries.">
          <UnorderedListOutlined
            style={{ fontSize: props.size, ...props.style }}
          />
        </Tooltip>
      );
    }

    case ItemType.REPORTS: {
      return (
        <Tooltip title="Report - a logical collection of topics.">
          <BookOutlined style={{ fontSize: props.size, ...props.style }} />
        </Tooltip>
      );
    }
  }
};
